import { FunctionsHttpError } from '@supabase/supabase-js'
import { supabase } from '../lib/supabase'

export type Fonte = { titulo: string; achados: string[] }
export type Mensagem = { papel: 'pessoa' | 'ia'; texto: string }

/** O mesmo formato da função chat-ia (supabase/functions/chat-ia/handler.ts). */
export type RespostaChat = {
  tipo: 'ia' | 'esclarecer' | 'fontes'
  texto: string
  fontes: Fonte[]
  sugestoes: string[]
  modelo: string | null
  avisos: string[]
}

/** `periodoTela`: o período do painel de onde a pergunta saiu (vale quando a pergunta não diz outro). */
export async function perguntar(
  pergunta: string,
  historico: Mensagem[],
  marcaFiltro: string,
  periodoTela?: { inicio: string; fim: string },
): Promise<RespostaChat> {
  const { data, error } = await supabase.functions.invoke('chat-ia', {
    body: { pergunta, historico: historico.slice(-6), marca_filtro: marcaFiltro || null, periodo_tela: periodoTela ?? null },
  })
  if (error) {
    const detalhe = error instanceof FunctionsHttpError ? await error.context.json().catch(() => null) : null
    throw new Error(detalhe?.erro ?? error.message)
  }
  return data as RespostaChat
}
